import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('gridFreeFormStore', Object.keys(getters)),
	...mapState('gridFreeFormStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('gridFreeFormStore', Object.keys(actions)),
	...mapMutations('gridFreeFormStore', Object.keys(mutations))
};
